import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./utilities/axios";

// Components
import Header from "./components/Header";
import Login from "./pages/Login";
// import Subcriptions from "./components/SubScriptionsTab/Subcriptions";
// import Payments from "./components/PaymentMethods";
// import Activity from "./components/Activity";
// import Addresses from "./components/Addresses";
// import PurchaseFlow from "./components/FreeTab/PurchaseFlowHr";
import Free from "./components/SubScriptionsTab/Free";

// Context Provider
import { TabVisibilityProvider } from "./components/FreeTab/TabVisibility";
import PlanDetails from "./components/FreeTab/PlanDetails";
import SubscriptionPlans from "./components/FreeTab/PurchaseFlowHr";
import SubscriptionPlansFiles from "./components/FreeTab/purchaseFlowFiles";
import SubscriptionPlansEsign from "./components/FreeTab/purchaseFlowEsign";
import SubscriptionPlansProjects from "./components/FreeTab/purchaseFlowProjects";
import SubscriptionPlansChat from "./components/FreeTab/purchaseFlowChat";
import SubscriptionPlansWorkSuite from "./components/FreeTab/purchaseFlowWorkSuite";
import SubscriptionPlansCampaigns from "./components/FreeTab/purchaseFlowCampaigns";
// import SubscriptionPlansFiles from "./components/FreeTab/PurchaseFlowFiles";
// import SubscriptionPlansESign from "./components/FreeTab/PurchaseFlowEsign";
// import SubscriptionPlansProjects from "./components/FreeTab/PurchaseFlowProjects";
// import SubscriptionPlansProjects from "./components/FreeTab/PurchaseFlowProjects"
import BottomNavBar from "./components/BottumNavBar";
import PayStep from "./components/FreeTab/PayStep";
import PayStepFiles from "./components/FreeTab/PayStepFiles";
import PayStepEsign from "./components/FreeTab/PayStepEsign";
import PayStepProjects from "./components/FreeTab/PayStepProjects";
import PayStepChat from "./components/FreeTab/PayStepChat";
import PayStepWorkSuite from "./components/FreeTab/PayStepWorkSuite";
import PayStepCampaigns from "./components/FreeTab/PayStepCampaigns";
import Subscriptions from "./components/SubScriptionsTab/Subscriptions";
import ConfirmSubscription from "./components/FreeTab/ConfirmSubscription";
import ScrollToTop from "./hooks/scrollToTop";
import PaymentMethods from "./components/PaymentMethods/PaymentMethod";
import Addresses from "./components/Addresses/Addresses";
import AddressDetail from "./components/Addresses/AddressDetails";
import MyStore from "./components/MyStore/MyStore";
import Activity from "./components/Activity/Activity";
import { Elements } from "@stripe/react-stripe-js";
// import Sidebar from "./components/SubScriptionsTab/leftMenu";
import { loadStripe } from "@stripe/stripe-js";
import { env } from "./utilities/function";
import ThemeContextProvider from "./style/theme";
import { CssBaseline } from "@mui/material";

const stripePromise = loadStripe(env("STRIPE_PUBLISHING_KEY"));

const App = () => {
  return (
    <Elements stripe={stripePromise}>
      <TabVisibilityProvider>
        <ScrollToTop />
        <Routes>
          {/* Unprotected Login Route */}
  
            <Route path="/login" element={ 
              <ThemeContextProvider>
                <CssBaseline />
                <Login />
              </ThemeContextProvider>
            } />
          {/* Protected Routes wrapped in Header */}
          <Route
            path="/*"
            element={
              <Header>
                <Routes>
                  <Route
                    path="/"
                    element={<Navigate to="/myStore" replace />}
                  />
                  <Route path="/subscription" element={<Subscriptions />} />
                  <Route path="/myStore" element={<MyStore />} />
                  <Route path="/payments" element={<PaymentMethods />} />
                  <Route path="/activity" element={<Activity />} />
                  <Route path="/address" element={<Addresses />} />
                  <Route path="/address/details" element={<AddressDetail />} />
                  <Route
                    path="/subscription/hr/purchase/:id"
                    element={<SubscriptionPlans />}
                  />
                  <Route
                    path="/subscription/files/purchase"
                    element={<SubscriptionPlansFiles />}
                  />
                  <Route
                    path="/subscription/esign/purchase"
                    element={<SubscriptionPlansEsign />}
                  />
                  <Route
                    path="/subscription/projects/purchase/:id"
                    element={<SubscriptionPlansProjects />}
                  />
                  <Route
                    path="/subscription/chat/purchase/:id"
                    element={<SubscriptionPlansChat />}
                  />
                  <Route
                    path="/subscription/worksuite/purchase/:id"
                    element={<SubscriptionPlansWorkSuite />}
                  />
                  <Route
                    path="/subscription/campaigns/purchase/:id"
                    element={<SubscriptionPlansCampaigns />}
                  />
                  <Route path="/free" element={<Free />} />
                  <Route
                    path="/plan-details/:planId"
                    element={<PlanDetails />}
                  />
                  <Route path="/pay-step" element={<PayStep />} />
                  <Route path="/pay-step-files" element={<PayStepFiles />} />
                  <Route path="/pay-step-esign" element={<PayStepEsign />} />
                  <Route
                    path="/pay-step-projects"
                    element={<PayStepProjects />}
                  />
                  <Route
                    path="/pay-step-chat"
                    element={<PayStepChat />}
                  />
                  <Route
                    path="/pay-step-worksuite"
                    element={<PayStepWorkSuite />}
                  />
                  <Route
                    path="/pay-step-campaigns"
                    element={<PayStepCampaigns />}
                  />
                  <Route
                    path="/confirm-subscription"
                    element={<ConfirmSubscription />}
                  />
                </Routes>
                <BottomNavBar />
              </Header>
            }
          />
        </Routes>
      </TabVisibilityProvider>
    </Elements>
  );
};

export default App;
